import { render } from "./ExpedientDetailForm.vue?vue&type=template&id=306f3b07"
import script from "./ExpedientDetailForm.vue?vue&type=script&lang=js"
export * from "./ExpedientDetailForm.vue?vue&type=script&lang=js"

import exportComponent from "/data/api/peitho-pre.uniqoderslab.com/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__